import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const WayfinderRedirect = () => {
  const { userId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (userId) {
      navigate(`/wayfinder/categories/${userId}`, { replace: true });
    }
  }, [userId, navigate]);

  return null;
};

export default WayfinderRedirect;
